module.exports = __webpack_public_path__ + "img/path-3.fdaf040d.svg";